import React from 'react';
import BrightnessMediumIcon from '@mui/icons-material/BrightnessMedium';
import { MenuItem } from '@mui/material';

import { toggleDarkTheme } from '../store/themeSlice';
import { useAppWithThemeDispatch } from './hooks';

export function ThemeToggleMenuItem() {
  const dispatch = useAppWithThemeDispatch();

  return (
    <MenuItem
      onClick={() => {
        dispatch(toggleDarkTheme());
      }}
    >
      <BrightnessMediumIcon sx={{ mr: 1 }} />
      Toggle Theme
    </MenuItem>
  );
}
